import Modal from "./Modal/Modal";
import React, { useState , useEffect } from "react";
import { useApp } from "../contexts";
import styled from "styled-components";
import { IconFemale } from "../components/Icons/IconFemale";
import CustomVideo from "../components/video/CustomVideo";

import { getPropByLanguage } from "../utils/Language";
import { ITEM_POSITION_ENUMS, ITEM_TYPES } from "../constants";
import NumberFormat from "react-number-format";
import { itemsBreed, roundNumber, formatCurrency } from "../services/app";
import {
  baseCurrencyCode,
  validateDecimalSeparator,
  prefixCcySymbol,
  suffixCcySymbol,
} from "../utils/Currency";
import IconMotion from "./Icons/IconMotion";
import IconPicture from "./Icons/IconPicture";
import VideoPlayer from "../components/video/MobileVideo";

const ContentWaper = styled.div`
  max-height: 80vh;
  overflow-y: auto;
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const ModalMintPreview = ({ value, ...props }) => {
  const {
    T,
    convertToLocalCurrency,
    formatLocalCurrency,
    getCurrency,
    language,
    setLoading,
  } = useApp();
  const { itemData, onClose, onSubmit, isMobile } = props; 
  const [price, setPrice] = useState(0);
  const [principalPrice, setPrincipalPrice] = useState(0);
  const [randomClass, setRandomClass] = useState("");
  const [breedOptions, setBreedOptions] = useState([]);
  const [rankOptions, setRankOptions] = useState([]);
  const [subData, setSubData] = useState([]);
  const [currentSub, setCurrentSub] = useState([]);
  const [openProperties, setOpenProperties] = useState(true);
  const [subTotalPrice, setSubTotalPrice] = useState(0);
  const [breadName, setBreadName] = useState("");
  const [rankName, setRankName] = useState("");
  const [categorySelected, setCategorySelected] = useState({});
  const [openOpportunityTokens, setOpenOpportunityTokens] = useState(true);
  const [opportunityTokens, setOpportunityTokens] = useState([]);
  const [collectionName, setCollectionName] = useState('')
  const [collectionList, setCollectionList] = useState([])
  const propLang = getPropByLanguage(language);
  useEffect(() => {
    if (itemData) {
      setPrice(
        convertToLocalCurrency(
          itemData?.item?.price,
          itemData?.item?.ccy,
          getCurrency()
        )
      );
      setPrincipalPrice(
        convertToLocalCurrency(
          itemData?.item?.principal_amount,
          "SZT",
          getCurrency()
        )
      );
      setOpportunityTokens(itemData?.opportunityTokens || []);
      setSubData(itemData?.allSubscriptions || []);    
      setCurrentSub(itemData?.allSubscriptions?.[0]?.subs?.[0] || null);
    }
  }, [itemData]);
  const loadBreeds = async () => {
    setLoading(true);
    let result = await itemsBreed(ITEM_TYPES.ITEM_TYPE_DOG);
    if (result.status === 200) {
      setBreedOptions(result?.data?.data?.categories || []);
      setRankOptions(result?.data?.data?.nftRanks || []);
      setCollectionList(result?.data?.data?.nftCollections || [])
    }
    setLoading(false);
  };
  useEffect(() => {
    loadBreeds()
  }, []);
  useEffect(() => {
    if (subData && subData.length > 0) {
      const subTotal = subData.reduce((summarySub, sub) => {
        const subTotalChild = sub.subs.reduce(
          (summaryChild, subChild) =>
            summaryChild + Number(subChild.price_in_usd),
          0
        );
        return summarySub + subTotalChild;
      }, 0);
      setSubTotalPrice(
        convertToLocalCurrency(subTotal, "USD", getCurrency())
      );
    }
  }, [subData]);
  useEffect(() => {
    if (collectionList.length > 0 && itemData?.item) {
        const collectionSelected = collectionList.find((i) => i.collectionGroup === itemData?.item?.collection_code_name)
        setCollectionName(collectionSelected?.groupNameTranslate[propLang] || collectionSelected?.defaultName)
    }
}, [collectionList, itemData?.item])

  useEffect(() => {
    if (itemData?.item && breedOptions?.length > 0) {
      const breedSelected = breedOptions.find(
        (item) => item.id == itemData?.item?.nft_type_category_id
      );
      if (breedSelected) {
        setBreadName(breedSelected.nameTranslate[getPropByLanguage(language)]);
        setCategorySelected(breedSelected);
      }
    }
  }, [breedOptions, itemData]);  
  
  useEffect(() => {
    if (itemData?.item && rankOptions?.length > 0) {
      const dogLevelsSelected = rankOptions?.find((lvl) => lvl.rankCode == itemData?.item?.rankCode)
      setRankName(
        dogLevelsSelected?.rankNameTranslate[getPropByLanguage(language)] || ""
      );
    }
  }, [rankOptions, itemData?.item]);

  useEffect(() => {
    const arr = Array.from({ length: 7 }, (_, i) => i + 1);
    const random = itemData?.item?.id % 7;
    setRandomClass(`suzu-card-image-${arr[random]}`);
  }, [itemData]);
  
  return (
    <Modal onClose={onClose}>
      <Modal.ModalBg2 onClose={onClose} />
      <Modal.Container2
        width="850px"
        className={"modal-mint"}
        onClose={onClose}
      >
        <ContentWaper>
          <div className="modal-content-row">
            <div className="modal-content-left w-full lg:max-h-none lg:h-auto">
              <div className=" bg-[#F5F5F5] rounded-[20px]">
                <div
                  className={`w-full ${itemData?.item?.tag_nft_type == 'motion' ? 'bg-slate-100' : randomClass} rounded-t-[20px] item-image-inner relative overflow-hidden`}
                >
                  { itemData?.item?.tag_nft_type == 'motion'? <>
                    {
                      isMobile ? <>
                      <VideoPlayer source={itemData?.item?.long_video_url} className={'flex justify-center'} isShowControls={true}/>

                      </> : <CustomVideo source={itemData?.item?.long_video_url} className={'flex justify-center no-border-b'} isShowControls={true}/>
                    }
                    
                  </>:<img
                    className={`w-full h-full object-cover`}
                    src={itemData?.item?.img}
                    onContextMenu={(e) => e.preventDefault()}
                    alt=""
                  />}
                  
                 
                  {subData?.length > 0 || itemData?.item?.tag_nft_type ? (
                    <div className="absolute top-[16px] left-[18px] flex justify-start space-x-2">
                       {itemData?.item?.tag_nft_type == 'photo' ? <div className="item-tag item-picture !top-0 !left-0 !relative">
                      <IconPicture /><span>{T('Photo')}</span>
                      </div>: <></>}
                      {itemData?.item?.tag_nft_type == 'motion' ? <div className="item-tag item-motion  !top-0 !left-0 !relative">
                          <IconMotion /> <span>{T('Motion')}</span>
                      </div>: <></>}
                      {subData?.length > 0 && (
                        <div className="flex justify-start item-has-sub gap-[5px] text-[12px] bg-[#E9A033] rounded-[100px] items-center text-white font-[500] px-3 py-[6px] tag-boxshadow">
                          <svg
                            width="15"
                            height="14"
                            viewBox="0 0 15 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            className="w-[12px]"
                          >
                            <path
                              d="M7.90725 0.301079L9.44059 4.84081L14.2315 4.89628C14.6438 4.90108 14.8145 5.42641 14.4838 5.67228L10.6401 8.53308L12.0678 13.1069C12.1905 13.5005 11.7441 13.8248 11.4075 13.5864L7.49925 10.8147L3.59045 13.5859C3.25445 13.8243 2.80752 13.4995 2.93018 13.1064L4.35792 8.53255L0.514184 5.67175C0.183518 5.42588 0.354184 4.90055 0.766451 4.89575L5.55738 4.84028L7.09072 0.300546C7.22298 -0.0898541 7.77552 -0.0898542 7.90725 0.301079Z"
                              fill="white"
                            />
                          </svg>
                          <div>{T("Art Plus")}</div>
                        </div>
                      )}
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                <div className="flex justify-between items-start px-[16px] py-[16px]">
                  <div className="flex flex-col truncate">
                    <div className="text-[#131516] text-[20px] truncate mb-[5px] font-bold">
                      {breadName}
                    </div>
                    <div className="h-[37px]">
                      <span
                        className={`rounded-[30px] px-[16px] text-[12px]/[18px]  xs:px-[10px] py-[6px]
                        ${
                          itemData?.item?.position ==
                          ITEM_POSITION_ENUMS.ITEM_POSITION_APP
                            ? "tag-inapp"
                            : "tag-inmarket"
                        }`}
                      >
                        {itemData?.item?.position ==
                        ITEM_POSITION_ENUMS.ITEM_POSITION_APP
                          ? T("In app")
                          : T("In market")}
                      </span>
                    </div>
                  </div>
                  <div className="flex flex-col justify-end">
                    {price > 0 && (
                      <div className="text-aia-red text-[20px] font-bold">
                        <NumberFormat
                          value={formatLocalCurrency(roundNumber(price, 2))}
                          displayType={"text"}
                          thousandSeparator={true}
                          prefix={prefixCcySymbol(true, getCurrency())}
                          suffix={suffixCcySymbol(true, getCurrency())}
                          decimalScale={validateDecimalSeparator(
                            baseCurrencyCode(true, getCurrency())
                          )}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-content-right flex flex-col bg-[#F5F5F5] rounded-[20px] px-[16px] pt-[30px] pb-[16px]">
              <div className="properties-block flex-1">
                <div className="flex justify-between items-center mb-[12px] lg:mb-[15px]">
                  <span className="text-black text-[22px]/[30px] font-bold font-manrope">
                    {T("Properties")}
                  </span>
                  <span onClick={() => setOpenProperties(!openProperties)}>
                    <svg
                      width="24"
                      className={`w-[16px] cursor-pointer ${
                        openProperties ? "rotate-180" : ""
                      }`}
                      height="14"
                      viewBox="0 0 24 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M2 2L12 12L22 2"
                        stroke="black"
                        strokeWidth="2.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </span>
                </div>
                {openProperties && (
                  <>
                    <div className="flex items-center justify-between grow-1">
                      <span className="text-[14px] text-[#989898] lg:text-[16px]">
                        {T("ID")}
                      </span>
                      <span className="h-[36px] text-center text-[14px] lg:text-[16px] leading-[36px] ">
                        #{itemData?.item?.id}
                      </span>
                    </div>
                    {categorySelected &&
                    categorySelected.collectionType !== 0 ? (
                      <></>
                    ) : (
                      <>
                        <div className="flex items-center justify-between grow-1">
                          <span className="text-[14px] lg:text-[16px] text-[#989898]">
                            {T("Gender")}
                          </span>
                          <span className="h-[36px] text-center text-[14px] lg:text-[16px] leading-[36px] ">
                            {itemData?.item?.sex == 1 ? (
                              <>
                                <div className="flex justify-end items-center">
                                  <IconFemale /> {T("Male")}
                                </div>
                              </>
                            ) : (
                              <>
                                <div className="flex justify-end items-center">
                                  <IconFemale /> {T("Female")}
                                </div>
                              </>
                            )}
                          </span>
                        </div>
                      </>
                    )}
                    <div className="flex items-center justify-between grow-1">
                      <span className="text-[14px] lg:text-[16px] text-[#989898]">
                        {T("Rank")}
                      </span>
                      <span className="h-[36px]  text-center text-[14px] lg:text-[16px] leading-[36px] ">
                        {rankName || ""}
                      </span>
                    </div>
                    {categorySelected && itemData?.item?.edition_number > 0 &&
                    categorySelected.collectionType !== 0 ? (
                      <>
                        <div className="flex items-center justify-between grow-1">
                          <span className="text-[14px] lg:text-[16px] text-[#989898]">
                            {T("Edition")}
                          </span>
                          <span className="h-[36px]  text-[#F12E11] font-semibold text-center text-[14px] lg:text-[16px] leading-[36px]">
                            {itemData?.item?.edition_number}
                            {categorySelected?.boxTotal ? `/${categorySelected?.boxTotal}`: ''}
                          </span>
                        </div>
                      </>
                    ) : (
                      <></>
                    )}
                    <div className="flex items-center justify-between grow-1">
                      <span className="text-[14px] lg:text-[16px] text-[#989898]">
                        {T("Type")}
                      </span>
                      <span className="h-[36px] text-center text-[14px] lg:text-[16px] leading-[36px]">
                        {itemData?.item?.tag_nft_type ? (itemData?.item?.tag_nft_type == 'motion'? T('Motion Art') : T('Photo Art')) : ''}
                      </span>
                    </div>
                    {itemData?.item?.tag_nft_type == 'motion' ?<div className="flex items-center justify-between grow-1">
                      <span className="text-[14px] lg:text-[16px] text-[#989898]">
                        {T("Author")}
                      </span>
                      <span className="h-[36px] text-center text-[14px] lg:text-[16px] leading-[36px]">
                        {itemData?.item?.author}
                      </span>
                    </div>: <></>}
                    <div className="flex items-center justify-between grow-1">
                      <span className="text-[14px] lg:text-[16px] text-[#989898]">
                        {T("Collection")}
                      </span>
                      <span className="h-[36px] text-center text-[14px] lg:text-[16px] leading-[36px]">
                        {collectionName}
                      </span>
                    </div>

                  </>
                )}
              </div>
              {subData?.length > 0 && currentSub && (
                <div className="properties-block mt-[20px] lg:mb-[30px]">
                  <div className="flex justify-between items-center mb-[12px] lg:mb-[22px]">
                    <span className="text-black text-[22px]/[30px] font-bold font-manrope">
                      {T("ART PLUS")}
                    </span>
                  </div>
                  <div className="property-content">
                    <div className="flex justify-between space-x-2">
                      <div className="sub-image min-w-[83px] w-[83px] h-[83px] rounded-[10px]">
                        <img src={currentSub.product_image} alt="" />
                      </div>
                      <div className="max-w-[164px] flex w-full flex-col">
                        <div className="flex justify-between leading-[21px] space-x-3 items-center">
                          <div className="text-[#989898] font-normal text-[12px] min-w-[100px]">
                            {T("Quantity:")}
                          </div>
                          <div className="text-[#101828] font-medium text-[12px] ">
                            {subData?.length}
                          </div>
                        </div>
                        <div className="flex justify-between leading-[21px] space-x-3 mt-[6px] items-center">
                          <div className="text-[#989898] font-normal text-[12px] min-w-[100px]">
                            {T("Monthly subtotal:")}
                          </div>
                          <div className="text-[#101828] font-medium text-[12px]">
                            <NumberFormat
                              value={formatLocalCurrency(
                                roundNumber(subTotalPrice, 2)
                              )}
                              displayType={"text"}
                              thousandSeparator={true}
                              prefix={prefixCcySymbol(true, getCurrency())}
                              suffix={suffixCcySymbol(true, getCurrency())}
                              decimalScale={validateDecimalSeparator(
                                baseCurrencyCode(true, getCurrency())
                              )}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {opportunityTokens?.length > 0 && (
                <div className="properties-block mt-[20px]">
                  <div className="flex justify-between items-center mb-[12px] lg:mb-[22px]">
                    <span className="text-black text-[22px]/[30px] font-bold font-manrope">
                      {T("Opportunity token")}
                    </span>
                    <span
                      onClick={() =>
                        setOpenOpportunityTokens(!openOpportunityTokens)
                      }
                    >
                      <svg
                        width="24"
                        className={`w-[16px] cursor-pointer ${
                          openOpportunityTokens ? "rotate-180" : ""
                        }`}
                        height="14"
                        viewBox="0 0 24 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M2 2L12 12L22 2"
                          stroke="black"
                          strokeWidth="2.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </span>
                  </div>
                  {openOpportunityTokens && (
                    <>
                      {opportunityTokens.map((opportunity) => (
                        <div className="flex items-center justify-between grow-1">
                          <span className="text-[14px] lg:text-[16px]">
                            {opportunity.currency}
                          </span>
                          <span className="h-[36px] lg:h-[40px] text-center text-[14px] lg:text-[16px] leading-[36px] lg:leading-[40px]">
                            {opportunity.balance
                              ? formatCurrency(opportunity.balance, 2)
                              : 0}
                          </span>
                        </div>
                      ))}
                    </>
                  )}
                </div>
              )}
              <div className="mt-[30px] mb-[20px] md:mb-[10px] flex flex-wrap flex-col-reverse md:flex-row md:flex-nowrap justify-center items-center gap-[20px]">
                <button
                  type="button"
                  className="bg-black leading-[52px] !text-white rounded-[15px] w-full px-[20px] h-[52px]"
                  onClick={() => onSubmit()}
                >
                  {T("OK")}
                </button>
              </div>
            </div>
          </div>
        </ContentWaper>
      </Modal.Container2>
    </Modal>
  );
};
